<template>
  <div class="container">
    <v-row>
      <v-col>
      <v-data-table
        :headers="headers2"
        :items="items2"
        :loading="loadingNextInvoices"
        loading-text="Φόρτωση επόμενων τιμολογήσεων..."
        no-data-text="Δεν υπάρχουν εκκρεμείς επόμενες τιμολογήσεις"
        class="elevation-1"
        disable-pagination
        disable-filtering
        hide-default-footer
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :custom-sort="customSort"
      >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title class="font-weight-bold">Επόμενες τιμολογήσεις</v-toolbar-title>
          <v-chip class="ml-3 font-weight-bold" small color="primary" outlined>
            {{ items2.length }} προς τιμολόγηση
          </v-chip>
          <v-spacer></v-spacer>

          <v-btn-toggle
            v-model="invoiceFilter"
            mandatory
            dense
            rounded
            active-class="primary white--text"
            class="elevation-1"
          >
            <v-btn small value="current_month" class="px-3">
              <v-icon left small>mdi-calendar-today</v-icon>
              Τρέχων Μήνας
            </v-btn>
            <v-btn small value="next_month" class="px-3">
              <v-icon left small>mdi-calendar-clock</v-icon>
              Επόμενος Μήνας
            </v-btn>
            <v-btn small value="year" class="px-3">
              <v-icon left small>mdi-calendar-range</v-icon>
              Τρέχον Έτος
            </v-btn>
            <v-btn small value="all" class="px-3">
              <v-icon left small>mdi-calendar-multiple</v-icon>
              Όλες οι ατιμολόγητες
            </v-btn>
            <v-btn small value="overdue" class="px-3" v-if="overdueInvoicesCount > 0">
              <v-icon left small color="error">mdi-alert-circle-outline</v-icon>
              Εκπρόθεσμες Τιμολόγησης ({{ overdueInvoicesCount }})
            </v-btn>
          </v-btn-toggle>

          <v-dialog v-model="dialogInvoice" max-width="550px" :persistent="invoiceButtonWorking">
            <v-card>
              <v-card-title class="text-h5">Εκδοση Τιμολογίου Σύμβασης - <span class="font-bold">{{ editedItem.contract }}</span></v-card-title>
              <v-card-text>
                <v-container class="m-2">
                  <!-- <v-row>
                    <v-text-field label="Σύμβαση" v-model="editedItem.contract" readonly/>
                  </v-row> -->

                  <v-row>
                    <v-col>
                      <v-text-field label="Πελάτης" v-model="editedItem.customer" readonly/>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="col-8">
                      <v-select
                        v-model="editedItem.document_type_id"
                        v-bind:items="documentTypes"
                        item-text="description"
                        item-value="id"
                        label="Τύπος Παραστατικού"
                      />
                    </v-col>
                    
                    <v-col class="col-4">
                      <v-select
                        v-model="editedItem.document_series_id"
                        v-bind:items="selectedDocumentSeries"
                        item-text="name"
                        item-value="id"
                        label="Σειρά"
                        v-bind:disabled="editedItem.document_type_id == null"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="col-6">
                      <v-select
                        v-model="editedItem.payment_type_id"
                        v-bind:items="paymentTypes"
                        item-text="description"
                        item-value="id"
                        label="Τρόπος πληρωμής"
                      />
                    </v-col>
                    <v-col class="col-6">
                      <template>
                        <vuetify-money
                        label="Ποσό χρέωσης"
                        v-model="editedItem.amount"
                        v-bind:options="moneyFieldOptions" readonly
                        />
                        
                      </template>
                    </v-col>
                  </v-row>


                  <v-row>
                    <v-col class="col-12">
                      <v-text-field
                      v-model="editedItem.override_description"
                      label="Περιγραφή χρέωσης"
                      disabled
                      />
                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col class="col-12">
                      <v-text-field
                      v-model="editedItem.comments"
                      label="Σχόλια παραστατικου"
                      />
                    </v-col>

                  </v-row>

                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeInvoice" :disabled="invoiceButtonWorking">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="invoiceConfirm" v-bind:loading="invoiceButtonWorking" v-bind:disabled="invoiceButtonDisabled || invoiceButtonWorking">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.amount`]="{ item }">
        {{ formatAmount(item.amount) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small @click="showInvoiceDialog(item)"> mdi-file-document </v-icon>
      </template>
    </v-data-table>
  </v-col>
    </v-row>

    <v-row>
      <v-col>
    
    <v-data-table
      :headers="headers"
      :items="filteredContracts"
      :loading="loadingContracts"
      loading-text="Φόρτωση συμβάσεων..."
      no-data-text="Δεν βρέθηκαν συμβάσεις"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer
      >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title class="font-weight-bold">Συμβάσεις</v-toolbar-title>
          <v-chip class="ml-3 font-weight-bold" small color="primary" outlined>
            {{ filteredContracts.length }} συμβάσεις
          </v-chip>
          <v-spacer></v-spacer>

          <v-btn-toggle
            v-model="contractFilter"
            mandatory
            dense
            rounded
            active-class="primary white--text"
            class="mr-4 elevation-1"
          >
            <v-btn small value="open" class="px-3">
              <v-icon left small color="success">mdi-check-circle-outline</v-icon>
              Ανοιχτές
            </v-btn>
            <v-btn small value="closed" class="px-3">
              <v-icon left small color="grey lighten-1">mdi-close-circle-outline</v-icon>
              Κλειστές
            </v-btn>
            <v-btn small value="all" class="px-3">
              <v-icon left small>mdi-format-list-bulleted</v-icon>
              Όλες
            </v-btn>
          </v-btn-toggle>

          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                color="primary" 
                rounded 
                elevation="2" 
                class="px-4 font-weight-bold white--text" 
                v-bind="attrs" 
                v-on="on"
              >
                <v-icon left size="20">mdi-plus</v-icon>
                <span>ΠΡΟΣΘΗΚΗ</span>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="8" sm="6">
                      <v-text-field
                        v-model="editedItem.title"
                        label="Τίτλος σύμβασης"
                        v-bind:error-messages="allerrors.title">
                      </v-text-field>
                      <v-autocomplete
                        label="Πελάτης"
                        v-model="editedItem.customer_id"
                        v-bind:items="customers"
                        item-text="name"
                        item-value="id"
                        clearable
                        v-bind:error-messages="allerrors.customer_id">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="8" sm="6">

                    
                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="editedItem.start_date"
                                label="Ημερομηνία έναρξης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                v-bind:error-messages="allerrors.start_date">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editedItem.start_date"
                            @input="menu1 = false">
                        </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="8" sm="6">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="editedItem.end_date"
                                label="Ημερομηνία λήξης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                v-bind:error-messages="allerrors.end_date">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editedItem.end_date"
                            @input="menu2 = false">
                        </v-date-picker>
                    </v-menu>
                  </v-col>

                  </v-row>

                  <v-row>
                    <v-col cols="12" md="8" sm="6">
                      <vuetify-money
                          label="Ποσό σύμβασης"
                          v-model="editedItem.total_amount"
                          v-bind:options="moneyFieldOptions"
                          v-bind:error-messages="allerrors.total_amount">
                      </vuetify-money>
                    </v-col>
                  </v-row>

                  <v-row v-if="editedIndex === -1">
                    <v-col cols="12" md="6" sm="6">
                      <v-select
                        v-model="editedItem.billing_frequency"
                        :items="frequencyOptions"
                        label="Συχνότητα τιμολόγησης"
                        dense
                        @change="onNewContractFrequencyChange"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6" sm="6" v-if="editedItem.billing_frequency !== 'weekly'">
                      <v-select
                        v-model="editedItem.billing_day"
                        :items="billingDayMonthOptions"
                        label="Ημέρα τιμολόγησης"
                        dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6" sm="6" v-else>
                      <v-select
                        v-model="editedItem.billing_day"
                        :items="billingDayWeekOptions"
                        label="Ημέρα εβδομάδας"
                        dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>              

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="save" v-bind:loading="saveButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.title }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.start_date`]="{ item }">
        {{ formatDate(item.start_date) }}
      </template>
      <template v-slot:[`item.end_date`]="{ item }">
        {{ formatDate(item.end_date) }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          x-small
          :color="isContractActive(item) ? 'success' : 'grey'"
          text-color="white"
          class="font-weight-medium"
        >
          {{ isContractActive(item) ? 'ΕΝΕΡΓΗ' : 'ΕΛΗΞΕ' }}
        </v-chip>
      </template>
      <template v-slot:[`item.total_amount`]="{ item }">
        {{ formatAmount(item.total_amount) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <span>
        <router-link :to="{name: 'contractpage', params: {id: item.id}}"> 	
          <v-icon small class="mr-2" color="primary" title="Προβολή σύμβασης"> mdi-folder-open </v-icon>
        </router-link>

        <v-icon small class="mr-2" @click="editItem(item)" title="Επεξεργασία σύμβασης"> mdi-pencil </v-icon>

        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </span>
      </template>
    </v-data-table>
  </v-col>

  </v-row>
  </div>
</template>

<script>
import { ToolbarItem } from "@syncfusion/ej2-vue-grids";
import axios from "axios";
import moment from "moment";
import { readonly } from "vue";

  export default {
    data: () => ({
      sortBy: ['scheduled_date'],
      sortDesc: [ false ],

      moneyFieldOptions: {
          locale: "el-GR",
          prefix: "€",
          suffix: "",
          length: 8,
          precision: 2
      },

      dialog: false,
      dialogDelete: false,

      dialogInvoice: false,
      
      
      headers2: [
        // {
        //   value: 'id',
        //   align: 'd-none'
        // },
        {
          text: 'Πελάτης',
          align: 'start',
          //sortable: false,
          value: 'customer',
        },
        {
          text: 'Σύμβαση',
          align: 'start',
          //sortable: false,
          value: 'contract',
        },
        {
          text: 'Ημερομηνία',
          align: 'start',
          //sortable: false,
          value: 'scheduled_date',
        },
        {
          text: 'Ποσό',
          align: 'right',
          //sortable: false,
          value: 'amount',
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],

      documentTypes: [],
      documentSeries: [],

      paymentTypes: [],

      headers: [
        {
          text: 'Πελάτης',
          align: 'start',
          //sortable: false,
          value: 'customer.name',
        },
        {
          text: 'Τίτλος',
          align: 'start',
          //sortable: false,
          value: 'title',
        },
        { 
          text: 'Έναρξη', 
          value: 'start_date' 
        },
        { 
          text: 'Λήξη', 
          value: 'end_date' 
        },
        { 
          text: 'Κατάσταση', 
          value: 'status',
          sortable: false
        },
        { 
          text: 'Ποσό', 
          value: 'total_amount',
          align: 'right'
        },


        { text: 'Actions', value: 'actions', sortable: false },
      ],
      allerrors: [],
      items: [],
      customers: [],
      menu1: false,
      menu2: false,

      nextInvoices: [],

      editedIndex: -1,
      editedItem: {
        
      },
      defaultItem: {
        
      },
      saveButtonDisabled: false,
      frequencyOptions: [
        { text: 'Κάθε Μήνα (Μηνιαία)', value: 'monthly' },
        { text: 'Κάθε Τρίμηνο (3 μήνες)', value: 'quarterly' },
        { text: 'Κάθε Εξάμηνο (6 μήνες)', value: 'semi_annually' },
        { text: 'Κάθε Χρόνο (Ετήσια)', value: 'annually' },
        { text: 'Κάθε Εβδομάδα (Εβδομαδιαία)', value: 'weekly' }
      ],
      billingDayMonthOptions: [
        { text: 'Τέλος Μήνα', value: 'end_of_month' },
        { text: '1η του μήνα', value: '1' },
        { text: '5η του μήνα', value: '5' },
        { text: '10η του μήνα', value: '10' },
        { text: '15η του μήνα', value: '15' },
        { text: '20ή του μήνα', value: '20' },
        { text: '25η του μήνα', value: '25' },
        { text: '30ή του μήνα', value: '30' }
      ],
      billingDayWeekOptions: [
        { text: 'Ημέρα έναρξης σύμβασης', value: 'start_day' },
        { text: 'Κάθε Δευτέρα', value: '1' },
        { text: 'Κάθε Τρίτη', value: '2' },
        { text: 'Κάθε Τετάρτη', value: '3' },
        { text: 'Κάθε Πέμπτη', value: '4' },
        { text: 'Κάθε Παρασκευή', value: '5' },
        { text: 'Κάθε Σάββατο', value: '6' },
        { text: 'Κάθε Κυριακή', value: '7' }
      ],
      deleteButtonDisabled: false,

      invoiceButtonWorking: false,
      loadingContracts: false,
      loadingNextInvoices: false,
      invoiceFilter: 'current_month',
      contractFilter: 'open'
    }),

    computed: {
      invoiceButtonDisabled() {
        if (this.editedItem == null)
          return true

        if (this.editedItem.document_type_id == null)
          return true

        if (this.editedItem.document_series_id == null)
          return true

        if (this.editedItem.payment_type_id == null)
          return true

        return false
      },

      selectedDocumentType() {
        return this.documentTypes.find(x => x.id == this.editedItem.document_type_id)
      },

      selectedDocumentSeries() {
        return this.selectedDocumentType?.series ?? []
      },

      invoiceInfoIncomplete() {
        return false
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Νέα Σύμβαση' : 'Επεξεργασία Σύμβασης'
      },

      editedItemName () {
        return 'yay'
      },

      filteredContracts() {
        if (!this.items || !Array.isArray(this.items)) {
          return [];
        }

        const today = moment().startOf('day');

        if (this.contractFilter === 'open') {
          return this.items.filter(x => {
            if (!x.end_date) return true;
            return moment(x.end_date).isSameOrAfter(today);
          });
        }

        if (this.contractFilter === 'closed') {
          return this.items.filter(x => {
            if (!x.end_date) return false;
            return moment(x.end_date).isBefore(today);
          });
        }

        return this.items;
      },

      overdueInvoicesCount() {
        if (!this.nextInvoices || !Array.isArray(this.nextInvoices)) return 0;
        const startOfCurrentMonth = moment().startOf('month').format('YYYY-MM-DD');
        return this.nextInvoices.filter(inv => inv.scheduled_date_iso && inv.scheduled_date_iso < startOfCurrentMonth).length;
      },

      items2() {
        if (!this.nextInvoices || !Array.isArray(this.nextInvoices) || this.nextInvoices.length === 0) {
          return [];
        }

        const contractsList = Array.isArray(this.items) ? this.items : [];
        const startOfCurrentMonth = moment().startOf('month').format('YYYY-MM-DD');
        const endOfCurrentMonth = moment().endOf('month').format('YYYY-MM-DD');

        const startOfNextMonth = moment().add(1, 'month').startOf('month').format('YYYY-MM-DD');
        const endOfNextMonth = moment().add(1, 'month').endOf('month').format('YYYY-MM-DD');

        const startOfYear = moment().startOf('year').format('YYYY-MM-DD');
        const endOfYear = moment().endOf('year').format('YYYY-MM-DD');

        let rawInvoices = this.nextInvoices;

        if (this.invoiceFilter === 'current_month') {
          rawInvoices = rawInvoices.filter(inv => {
            if (!inv.scheduled_date_iso) return false;
            return inv.scheduled_date_iso >= startOfCurrentMonth && inv.scheduled_date_iso <= endOfCurrentMonth;
          });
        } else if (this.invoiceFilter === 'next_month') {
          rawInvoices = rawInvoices.filter(inv => {
            if (!inv.scheduled_date_iso) return false;
            return inv.scheduled_date_iso >= startOfNextMonth && inv.scheduled_date_iso <= endOfNextMonth;
          });
        } else if (this.invoiceFilter === 'year') {
          rawInvoices = rawInvoices.filter(inv => {
            if (!inv.scheduled_date_iso) return false;
            return inv.scheduled_date_iso >= startOfYear && inv.scheduled_date_iso <= endOfYear;
          });
        } else if (this.invoiceFilter === 'overdue') {
          rawInvoices = rawInvoices.filter(inv => {
            if (!inv.scheduled_date_iso) return false;
            return inv.scheduled_date_iso < startOfCurrentMonth;
          });
        }

        const list = [];
        for (let i = 0; i < rawInvoices.length; i++) {
          const invoice = rawInvoices[i];
          if (!invoice) continue;

          const contract = contractsList.find(x => x && x.id == invoice.contract_id);

          list.push({
            id: invoice.id,
            contract_id: invoice.contract_id,
            scheduled_date_iso: invoice.scheduled_date_iso,
            customer_id: invoice.customer_id || (contract && contract.customer ? contract.customer.id : (contract ? contract.customer_id : null)),
            customer: invoice.customer_name || (contract && contract.customer ? contract.customer.name : '—'),
            contract: invoice.contract_title || (contract && contract.title ? contract.title : `Σύμβαση #${invoice.contract_id}`),
            scheduled_date: invoice.scheduled_date ?? '',
            amount: invoice.amount ?? '',
            suggested_document_type_id: invoice.suggested_document_type_id || (contract ? contract.suggested_document_type_id : null),
            suggested_document_series_id: invoice.suggested_document_series_id || (contract ? contract.suggested_document_series_id : null),
            suggested_payment_type_id: invoice.suggested_payment_type_id || (contract ? contract.suggested_payment_type_id : null),
          });
        }
        return list;
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialogInvoice (val) {
        val || this.closeInvoice()
      },

      selectedDocumentType(val) {
        if (val == null)
          return

        if (this.editedItem.override_description == null)
          this.editedItem.override_description = val.charges[0].description

        if (val.series.length == 1)
          this.editedItem.document_series_id = val.series[0].id
      },

    },

    

    created () {
      this.initialize()
    },

    methods: {

      customSort(items, sortBy, sortDesc) {
        if (!sortBy || !sortBy.length) return items;
        const key = sortBy[0];
        const desc = sortDesc && sortDesc.length ? sortDesc[0] : false;

        return items.slice().sort((a, b) => {
          let valA = a ? a[key] : null;
          let valB = b ? b[key] : null;

          if (valA == null && valB == null) return 0;
          if (valA == null) return desc ? 1 : -1;
          if (valB == null) return desc ? -1 : 1;

          // Handle dd/mm/yyyy dates
          if (key === 'scheduled_date' && typeof valA === 'string' && typeof valB === 'string') {
            const parseDate = (str) => {
              const parts = str.split('/');
              if (parts.length === 3) {
                return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0])).getTime();
              }
              return 0;
            };
            valA = parseDate(valA);
            valB = parseDate(valB);
          }

          if (valA < valB) return desc ? 1 : -1;
          if (valA > valB) return desc ? -1 : 1;

          return 0;
        });
      },


      formatDate(value) {
        if (!value) return '—';
        return moment(value).format("DD/MM/YYYY");
      },

      formatAmount(val) {
        if (val == null || val === '') return '€ 0,00';
        return '€ ' + Number(val).toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },

      isContractActive(contract) {
        if (!contract || !contract.end_date) return true;
        return moment(contract.end_date).isSameOrAfter(moment().startOf('day'));
      },

      showInvoiceDialog(item) {
        this.editedItem = Object.assign({}, item);

        const contract = this.items.find(x => x && x.id == item.contract_id);

        this.editedItem.document_type_id = item.suggested_document_type_id || (contract ? contract.suggested_document_type_id : null);
        this.editedItem.document_series_id = item.suggested_document_series_id || (contract ? contract.suggested_document_series_id : null);
        this.editedItem.payment_type_id = item.suggested_payment_type_id || (contract ? contract.suggested_payment_type_id : null);

        const title = item.contract || (contract ? contract.title : '');
        this.editedItem.override_description = `ΒΑΣΗ ΣΥΜΒΑΣΗΣ - ${title}`;

        this.dialogInvoice = true;
      },

      closeInvoice() {
        this.dialogInvoice = false;
        this.editedItem = {};
      },

      invoiceConfirm() {
        if (this.invoiceButtonWorking) return;
        this.invoiceButtonWorking = true;

        const request = {
          document_type_id: this.editedItem.document_type_id,
          document_series_id: this.editedItem.document_series_id,
          
          contract_id: this.editedItem.contract_id,
          customer_id: this.editedItem.customer_id,
          contract_invoice_schedule_id: this.editedItem.id,
          document_issue_date: moment().format('YYYY-MM-DD'),

          payment_type_id: this.editedItem.payment_type_id,
          amount: this.editedItem.amount,

          comments: this.editedItem.comments,
          
          charges: [
            {
              charge_type_id: this.selectedDocumentType.charges[0].id,
              override_description: this.editedItem.override_description,
              amount: this.editedItem.amount,
              gross_value: false
            }
          ]
        };

        // Close dialog immediately to prevent any accidental double-clicks or re-submission
        this.dialogInvoice = false;

        if (this.$swal) {
          this.$swal.fire({
            title: 'Έκδοση τιμολογίου',
            text: 'Γίνεται έκδοση παραστατικού και διαβίβαση... Παρακαλώ περιμένετε.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              this.$swal.showLoading();
            }
          });
        }

        axios.post('/api/contracts/invoice', request)
        .then(response => { 
          const documentUuid = response.data.uuid;

          this.initialize();

          if (this.$swal) {
            this.$swal.fire({
              icon: 'success',
              title: 'Επιτυχής Έκδοση!',
              text: 'Το τιμολόγιο εκδόθηκε επιτυχώς.',
              showCancelButton: !!documentUuid,
              confirmButtonText: documentUuid ? 'Προβολή PDF' : 'Εντάξει',
              cancelButtonText: 'Κλείσιμο',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#aaa'
            }).then((result) => {
              if (result.isConfirmed && documentUuid) {
                const win = window.open(`/invoices/pdf/${documentUuid}`, '_blank');
                if (win) {
                  win.focus();
                }
              }
            });
          }
        })
        .catch(error => { 
          console.error(error);
          const errorMsg = error.response?.data?.message || 'Παρουσιάστηκε σφάλμα κατά την έκδοση του τιμολογίου.';
          if (this.$swal) {
            this.$swal.fire({
              icon: 'error',
              title: 'Σφάλμα Έκδοσης',
              text: errorMsg
            });
          }
          this.initialize();
        })
        .finally(() => { 
          this.invoiceButtonWorking = false; 
        });
      },

      mixmatch(entry) {
        entry.customer = this.customers.find(customer => customer.id == entry.customer_id)
        return entry;
      },

      initialize () {
        this.loadingContracts = true;
        this.loadingNextInvoices = true;

        axios.get('/api/contracts')
          .then(res => {
            this.items = Array.isArray(res.data) ? res.data : (res.data?.data || []);
          })
          .catch(error => {
            console.error('Error fetching contracts:', error);
          })
          .finally(() => {
            this.loadingContracts = false;
          });

        axios.get('/api/contracts/next-invoices')
          .then(res => {
            this.nextInvoices = Array.isArray(res.data) ? res.data : (res.data?.data || []);
          })
          .catch(error => {
            console.error('Error fetching next invoices:', error);
          })
          .finally(() => {
            this.loadingNextInvoices = false;
          });

        axios.get('/api/accounts')
          .then(res => {
            this.customers = Array.isArray(res.data) ? res.data : (res.data?.data || []);
          })
          .catch(error => {
            console.error('Error fetching accounts:', error);
          });

        axios.get('/api/document-types/service')
          .then(res => {
            const raw = Array.isArray(res.data) ? res.data : (res.data?.data || []);
            this.documentTypes = raw.filter(x => x.debit == true);
          })
          .catch(error => {
            console.error('Error fetching service document types:', error);
          });

        axios.get('/api/tax-authority/payment-types')
          .then(res => {
            this.paymentTypes = Array.isArray(res.data) ? res.data : (res.data?.data || []);
          })
          .catch(error => {
            console.error('Error fetching payment types:', error);
          });
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        if (this.editedItem.start_date) {
          this.editedItem.start_date = moment(this.editedItem.start_date).format('YYYY-MM-DD');
        }
        if (this.editedItem.end_date) {
          this.editedItem.end_date = moment(this.editedItem.end_date).format('YYYY-MM-DD');
        }
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        if (this.editedItem.start_date) {
          this.editedItem.start_date = moment(this.editedItem.start_date).format('YYYY-MM-DD');
        }
        if (this.editedItem.end_date) {
          this.editedItem.end_date = moment(this.editedItem.end_date).format('YYYY-MM-DD');
        }
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true;
        axios.delete(`/api/contracts/${this.items[this.editedIndex].id}`)
        .then(response => { this.initialize(); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      close () {
        this.dialog = false
        this.allerrors = {}
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.allerrors = {}
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      onNewContractFrequencyChange() {
        if (this.editedItem.billing_frequency === 'weekly' && (!this.editedItem.billing_day || this.editedItem.billing_day === 'end_of_month')) {
          this.$set(this.editedItem, 'billing_day', 'start_day');
        } else if (this.editedItem.billing_frequency !== 'weekly' && this.editedItem.billing_day === 'start_day') {
          this.$set(this.editedItem, 'billing_day', 'end_of_month');
        }
      },

      save () {
        this.saveButtonDisabled = true;
        this.allerrors = {};
        
        let requestBody = {
          customer_id: this.editedItem.customer_id,
          start_date: this.editedItem.start_date,
          end_date: this.editedItem.end_date,
          title: this.editedItem.title,
          total_amount: this.editedItem.total_amount,
          billing_frequency: this.editedItem.billing_frequency || 'monthly',
          billing_day: this.editedItem.billing_day || 'end_of_month'
        }

        const request = this.editedIndex > -1
          ? axios.patch('/api/contracts/' + this.editedItem.id, requestBody)
          : axios.post('/api/contracts', requestBody);

        request
        .then(response => { 
          if (this.$swal) {
            this.$swal.fire({
              icon: 'success',
              title: 'Επιτυχία',
              text: this.editedIndex > -1 ? 'Η σύμβαση ενημερώθηκε επιτυχώς.' : 'Η σύμβαση δημιουργήθηκε επιτυχώς.',
              timer: 2000,
              showConfirmButton: false
            });
          }
          this.initialize(); 
          this.close(); 
        })
        .catch(error => {
          console.error(error);
          this.allerrors = error.response?.data?.errors || {};
          const msg = error.response?.data?.message || 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση της σύμβασης.';
          if (this.$swal) {
            this.$swal.fire({
              icon: 'error',
              title: 'Σφάλμα αποθήκευσης',
              text: msg
            });
          }
        })
        .finally(() => {
          this.saveButtonDisabled = false;
        });
          
      },
    },
  }
</script>

<style>
</style>
